import { Grid } from "@mui/material";
import { useEffect, useRef } from "react";
import { Input } from "../../../components/Input";
import { ExSelectFilter } from "../../../components/ExSelectFilter";
import { isMobileDevice, formatDataCompare, toastError } from "../../../commons/utils";
import { model_plantio, model_safra } from "../../../models";
import { useAuth } from "../../../contexts/AuthProvider/useAuth";
import { forwardRef, useImperativeHandle } from "react";

interface Props {
    tab: string;
    data: any[];
    entradas?: any[];
    cultura: { id: string, descricao: string };
    onFilterChange: (res: { data: any[]; entradas?: any[] }) => void;
}

export const FiltroBaseSafraPlantio = forwardRef(function FiltroBaseSafraPlantio({ tab, data, entradas, cultura, onFilterChange }: Props, ref) {
    const auth = useAuth();

    const refIEmissao = useRef<any>(null);
    const refFEmissao = useRef<any>(null);
    const refSafra = useRef<any>(null);
    const refPlantio = useRef<any>(null);

    useImperativeHandle(ref, () => ({
        refresh: applyFilters
    }));

    function applyFilters(_data?: any, _entradas?: any) {
        if (!cultura) return;

        const iEmissao = refIEmissao.current?.getValue();
        const fEmissao = refFEmissao.current?.getValue();

        const aplicarFiltrosBase = (arr: any[]) => {
            let filtered = [...arr];

            if (iEmissao)
                filtered = filtered.filter((item: any) => formatDataCompare(item.movemissao) >= iEmissao);
            if (fEmissao)
                filtered = filtered.filter((item: any) => fEmissao >= formatDataCompare(item.movemissao));
            if (cultura)
                filtered = filtered.filter((item: any) => item.cultdescricao === cultura.descricao);

            if (refSafra.current) filtered = refSafra.current.applyFilter(filtered) || filtered;
            if (refPlantio.current) filtered = refPlantio.current.applyFilter(filtered) || filtered;

            return filtered;
        };

        const sourceData = Array.isArray(_data) && _data.length > 0 ? _data : data;

        const filteredData = aplicarFiltrosBase(sourceData);

        const sourceEntradas = Array.isArray(_entradas) && _entradas.length > 0 ? _entradas : entradas;
        const filteredEntradas = sourceEntradas ? aplicarFiltrosBase(sourceEntradas) : undefined;

        onFilterChange({ data: filteredData, entradas: filteredEntradas });
    }

    function handleChangeSafra(selected: any) {
        if (refPlantio.current) {
            if (selected?.length > 0)
                refPlantio.current.setFilter({ safraid: selected.map((i: any) => i.value) });
            else
                refPlantio.current.clearFilter();
        }
        applyFilters();
    }

    useEffect(() => {
        if (!cultura) return;

        async function changeCultura() {
            try {
                const response: any = await auth.get(model_plantio.api_get + '?cultid=' + cultura.id);
                const formattedData = response.data.map((item: any) => ({ value: item.plid, label: item.pldescricao, ativo: item.plativo }));

                await refPlantio.current?.setCustomOptions(formattedData);
                applyFilters();
            } catch (error) {
                toastError(error);
            }
        }

        changeCultura();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cultura]);

    return (
        <>
            <Grid item xs={isMobileDevice() ? 12 : 1.75}>
                <Input
                    ref={refIEmissao}
                    id={tab + "_iemissao"}
                    type="date"
                    label="Emissão Inicial"
                    onAfterChange={() => applyFilters()}
                />
            </Grid>
            <Grid item xs={isMobileDevice() ? 12 : 1.75}>
                <Input
                    ref={refFEmissao}
                    id={tab + "femissao"}
                    type="date"
                    label="Emissão Final"
                    onAfterChange={() => applyFilters()}
                />
            </Grid>
            <Grid item xs={isMobileDevice() ? 12 : 3.5}>
                <ExSelectFilter
                    ref={refSafra}
                    variant={tab}
                    model={model_safra}
                    onAfterChange={handleChangeSafra}
                />
            </Grid>
            <Grid item xs={isMobileDevice() ? 12 : 3.5}>
                <ExSelectFilter
                    ref={refPlantio}
                    variant={tab}
                    model={model_plantio}
                    onAfterChange={() => applyFilters()}
                />
            </Grid>
        </>
    );
});